import React from "react";
import * as S from "./styled";

const NoSearch = () => {
  return (
    <S.Wrapper>
      <h1>No user surveyed...</h1>
    </S.Wrapper>
  );
};

export default NoSearch;
